import { TableCell, TableRow } from "@mui/material";
import { ITableColumn } from "../../../../../../App/Typings/Table";
import { useHistory } from "react-router-dom";
import { Check, ErrorOutline } from "@mui/icons-material";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IAttributeTableCellProps {
  columns: ITableColumn[];
  element: any;
}

export default function AttributeTableCell({
  columns,
  element,
}: IAttributeTableCellProps) {
  const history = useHistory();

  function displayIsActive() {
    if (element.isActive) {
      return <Check sx={{ ml: "10%", color: "primary.main" }} />;
    } else {
      return <ErrorOutline sx={{ ml: "10%", color: "secondary.main" }} />;
    }
  }

  return (
    <>
      <TableRow
        hover
        key={element.id}
        sx={classes.rowCell}
        onClick={() =>
          history.push(`/abac/${element.appId}/attribute/${element.id}`)
        }
      >
        {columns.map((column: ITableColumn, elementIndex: number) => {
          let value = element[column.propName];
          if (value instanceof Date) {
            value = value.toLocaleDateString("en-US");
          }
          return (
            <TableCell key={elementIndex} align="left" sx={classes.tableCell}>
              {column.propName === "isActive" ? displayIsActive() : value}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}
